import './style.scss'

export default class invitationPoster {
  constructor() {
    this.$root = document.body
    this.invitationPoster = null
  }

  show(qrCodeImage) {
    if (!this.invitationPoster) {
      let template = document.createElement('div')
      template.style.opacity = 0
      template.classList.add('invitation-poster')
      let innerHTML = `
        <div class="invitation-wrap invitation-poster-container">
          <div class="invitation-poster-title">
            <span>只需1步：</span>
            <span>扫码获取专属邀请海报</span>
          </div>
          <ul>
            <li>邀请新答主来回答（邀请前无回答）</li>
            <li>新答主回答首次被标记星标，邀请者就可以获得<span>2元</span>奖金～</li>
            <li>新答主在10天内成长为1星答主，邀请者可以再获得<span>5元</span>奖金～</li>
          </ul>
          <div class="invitation-poster-qrcode">
            <img src="${qrCodeImage}" alt="">
          </div>
          <div class="invitation-poster-close"></div>
        </div>`
      template.innerHTML = innerHTML
      template.getElementsByClassName(
        'invitation-poster-close'
      )[0].onclick = () => {
        this.fadeOut(template)
      }
      this.invitationPoster = template
      this.$root.appendChild(template)

      this.fadeIn(template)
    } else {
      this.fadeIn(this.invitationPoster)
    }
  }

  showGuiderMap() {
    let template = document.createElement('div')
    template.style.opacity = 0
    template.classList.add('invitation-poster')
    let innerHTML = `
      <div class="invitation-wrap guider-map-container">
        <div class="guider-map-title">这里是属于你的互助社区</div>
        <div class="guider-map-text">让我们一起来治愈这个世界</div>
        <div class="guider-map-button">知道啦</div>
        <div class="invitation-poster-close"></div>
      </div>`
    template.innerHTML = innerHTML
    template.getElementsByClassName(
      'invitation-poster-close'
    )[0].onclick = () => {
      this.fadeOut(template)
    }
    template.getElementsByClassName('guider-map-button')[0].onclick = () => {
      this.fadeOut(template)
    }
    this.$root.appendChild(template)

    this.fadeIn(template)
  }

  fadeIn(elem, speed = 17, opacity = 100) {
    elem.style.display = 'block'
    let val = 0,
      fn = function() {
        elem.style.opacity = val / 100
        val += 5
        if (val <= opacity) {
          setTimeout(fn, speed)
        }
      }
    fn()
  }

  fadeOut(elem, speed = 17, opacity = 0) {
    let val = 100,
      fn = function() {
        elem.style.opacity = val / 100
        val -= 5
        if (val >= opacity) {
          setTimeout(fn, speed)
        } else if (val <= 0) {
          elem.style.display = 'none'
        }
      }
    fn()
  }
}



// WEBPACK FOOTER //
// ./src/public-resource/components/invitationPoster/index.js